import type {ApiResourceName} from '../../api/types';
import type {Nullable} from '../utility-types';

import {API_RESOURCE_NAMES} from '../../api/types';

export type EntityType = ApiResourceName;

export function getEntityTypeById(entityId: string): Nullable<EntityType> {
  const type = entityId.split(':')[0] as EntityType;

  return API_RESOURCE_NAMES.has(type) ? type : null;
}
